import { redirect } from '@tanstack/react-router'
import { getDefaultHomeForRole } from '@/lib/auth-redirect'
import { useAuthStore } from '@/stores/auth-store'
import { toast } from 'sonner'

export const requirePermission = (permission: string) => {
  return () => {
    const user = useAuthStore.getState().auth.user
    // If user is not loaded yet, we might want to wait or handle it? 
    // Assuming auth store is populated by the time we hit authenticated routes (AuthenticatedLayout ensures token, but maybe not user details if fetchUser is async?)
    // But existing code checked usage of `user`.

    if (!user) {
        // If no user but we are in authenticated route, something is wrong or loading.
        // But let's assume user object is present if filtered by parent route check.
        // If not, allow safe fail or redirect?
        // AuthenticatedLayout typically ensures user is fetched.
        return;
    }

    const hasPermission = user.permissions?.includes(permission)

    if (!hasPermission) {
      toast.error('You do not have permission to access this page')
      const role = user.role || user.type
      throw redirect({
        to: getDefaultHomeForRole(role),
        replace: true,
      })
    }
  }
}

export const requireRole = (roles: string | string[]) => {
  const allowed = Array.isArray(roles) ? roles : [roles]
  return () => {
    const user = useAuthStore.getState().auth.user
    if (!user) return

    const role = user.role || user.type
    if (!role || !allowed.includes(role)) {
      toast.error('You do not have access to this area')
      throw redirect({
        to: getDefaultHomeForRole(role),
        replace: true,
      })
    }
  }
}
